// removed by extract-text-webpack-plugin
module.exports = {"main_content":"components-studentPhotoMng-index-main_content-3LjGC","download":"components-studentPhotoMng-index-download-3GL5E","list_item_extra":"components-studentPhotoMng-index-list_item_extra-3bVRQ","list_item_extra_gril":"components-studentPhotoMng-index-list_item_extra_gril-1PBnp","list_item_extra_boy":"components-studentPhotoMng-index-list_item_extra_boy-IhuLJ","list_item_avatar":"components-studentPhotoMng-index-list_item_avatar-AE0hX","ant_back_top_inner":"components-studentPhotoMng-index-ant_back_top_inner-3Uibk","pagination_tip":"components-studentPhotoMng-index-pagination_tip-2sLpG"};


//////////////////
// WEBPACK FOOTER
// ./components/studentPhotoMng/index.css
// module id = 817
// module chunks = 0